import { defineStore } from 'pinia';
import { ref } from 'vue';

import { Status } from '../models/CommonModels';

export const useEwerpCommonStore = defineStore('ewerpCommonStore', () => {
  const status = ref<Status>(new Status());

  function setStatus(newStatus: Status): void {
    status.value = newStatus;
  }

  function toggleSidebar(): void {
    status.value.sidebarCollapsed = !status.value.sidebarCollapsed;
  }

  return {
    status,
    setStatus,
    toggleSidebar,
  };
});
